import { type BoxProps, Flex, Image } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { Action, LayoutV2, Pages } from "~/core";
import { useDirectus } from "~/shared/utils/directus/useDirectus";

import { FooterControls } from "./components/FooterControls";
import { FooterDescription } from "./components/FooterDescription";
import { FooterMenu } from "./components/FooterMenu";

export type FooterV4Props = {
  data: LayoutV2;
  getUrl: (page: Pages) => string;
  onCallAction: (action: Action) => void;
  isControlInactive: (control: Action) => boolean;
} & Partial<
  Omit<BoxProps, "display" | "as" | "children" | "className" | "onClick">
>;
export const FooterV4: FC<FooterV4Props> = (props) => {
  const { data, ...rest } = props;

  const { getDirectusImage } = useDirectus();
  return (
    <Flex
      d={{ p: { py: 64 } }}
      as="section"
      justify="center"
      flexDirection="column"
      align="center"
      {...rest}
    >
      {data?.footer_logo?.id && (
        <Flex justify="center" d={{ justify: "flex-start" }} width="100%">
          <Image
            value={getDirectusImage(data?.footer_logo?.id ?? "", {
              format: "webp",
              width: 190,
            })}
          />
        </Flex>
      )}

      <FooterMenu {...props} />

      <FooterControls {...props} />

      <FooterDescription {...props} />
    </Flex>
  );
};
